import { LoadingStyled } from "./styles";

import loadingIcon from "../../assets/imgs/loading_icon.svg";

interface LoadingProps {
	$width: string;
}

export const Loading = ({ $width }: LoadingProps) => {
	return (
		<LoadingStyled $width={$width}>
			<img src={loadingIcon} alt="loading" />
		</LoadingStyled>
	);
};
